import React from 'react';

const BACKEND_URL = import.meta.env.VITE_BACKEND_URL || "";

const adminUrl = import.meta.env.VITE_ADMIN_URL || "https://call.sharecoop.icloud.ec";
const guestUrl = import.meta.env.VITE_GUEST_URL || "https://join.sharecoop.icloud.ec";

export const RecordPage: React.FC = () => {

    // === ГЕНИАЛЬНЫЙ РЕДИРЕКТ ===
    // Если страница открыта на домене call, мгновенно перекидываем на join!
	if (window.location.origin === adminUrl) {
		  window.location.replace(`${guestUrl}/record${window.location.search}`);
		  return <div style={{ background: '#0a0a0a', height: '100vh', width: '100vw' }} />;
	  }
    // ===========================

    const urlParams = new URLSearchParams(window.location.search);
    const videoId = urlParams.get('v');
    const dateParam = urlParams.get('date');

    const isValidFile = videoId && (videoId.endsWith('.mp4') || videoId.endsWith('.mp3') || videoId.endsWith('.ogg'));
    
    if (!isValidFile || videoId.includes('/') || videoId.includes('\\')) {
        return (
            <div style={{ background: '#111', color: 'white', height: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <h2>Запись не найдена или ссылка недействительна</h2>
            </div>
        );
    }

    // Идеальный путь к бэкенду, который мы починили!
    const fileUrl = `${BACKEND_URL}/api/recordings/files/${videoId}`;
    
    let title = "Запись созвона";
	if (dateParam) {
		const parsedDate = new Date(dateParam);
		if (!isNaN(parsedDate.getTime())) {
			// ❗️ Добавили 'ru-RU', теперь всегда будет дд.мм.гггг
			title = `Запись от ${parsedDate.toLocaleDateString('ru-RU')}`;
		}
	}

    return (
        <div style={{ 
			position: 'absolute', 
			top: 0, left: 0, right: 0, bottom: 0, 
			overflowY: 'auto', 
			background: 'transparent', 
			color: 'white', 
			fontFamily: 'sans-serif',
			boxSizing: 'border-box',
			padding: '80px 20px 40px', // Верх, бока, низ
			display: 'flex', 
			flexDirection: 'column', 
			alignItems: 'center'
		}}>

            <div style={{ width: '100%', maxWidth: '1000px', background: '#1e1e1e', padding: '20px', borderRadius: '12px', boxShadow: '0 10px 30px rgba(0,0,0,0.5)' }}>
                
                {videoId.endsWith('.mp3') || videoId.endsWith('.ogg') ? (
                    <audio src={fileUrl} controls style={{ width: '100%', borderRadius: '8px' }} />
                ) : (
                    <video 
						src={fileUrl} 
						controls 
						controlsList="nodownload" 
						style={{ width: '100%', borderRadius: '8px', background: 'black', objectFit: 'cover', maxHeight: '600px' }}
					></video>
                )}
                
                <div style={{ marginTop: '20px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <h2 style={{ color: 'white', margin: 0, fontFamily: 'sans-serif' }}>{title}</h2>
                    <a href={fileUrl} download style={{ background: '#0fb165', color: 'white', padding: '12px 24px', textDecoration: 'none', borderRadius: '8px', fontWeight: 'bold', fontFamily: 'sans-serif', transition: '0.2s' }}>
                        Скачать запись
                    </a>
                </div>
            </div>
        </div>
    );
};
